/*
 * Color de la franja de arriba de una imagen (el promedio del 5% superior).
 *
 * Lo usa el header cuando no tiene imagen propia: toma el color con el que
 * empieza el fondo de la sección promocional que tiene debajo, así los dos se
 * funden sin línea de corte (un token fijo no coincide con la imagen que se
 * suba). Igual que medirTinta, pide la imagen con ?medir (otra entrada del
 * caché, con CORS) para que las <img> visibles no necesiten crossOrigin.
 *
 * Se guarda por URL en el celular: desde la segunda apertura el color está
 * desde el primer render.
 */
const CLAVE = 'color_arriba_v1';
const promesas = new Map();

const leerGuardados = () => {
  try { return JSON.parse(localStorage.getItem(CLAVE)) || {}; } catch { return {}; }
};

export const colorArribaGuardado = (url) => (url ? leerGuardados()[url] || null : null);

export function colorArriba(url) {
  if (!url) return Promise.resolve(null);
  if (promesas.has(url)) return promesas.get(url);

  const promesa = new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const w = 40;
        const h = Math.max(1, Math.round((img.naturalHeight / img.naturalWidth) * w));
        const lienzo = document.createElement('canvas');
        lienzo.width = w;
        lienzo.height = h;
        const ctx = lienzo.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        const { data } = ctx.getImageData(0, 0, w, Math.max(1, Math.round(h * 0.05)));
        const suma = [0, 0, 0];
        for (let i = 0; i < data.length; i += 4) { suma[0] += data[i]; suma[1] += data[i + 1]; suma[2] += data[i + 2]; }
        const n = data.length / 4;
        const color = `#${suma.map((v) => Math.round(v / n).toString(16).padStart(2, '0')).join('')}`;
        try { localStorage.setItem(CLAVE, JSON.stringify({ ...leerGuardados(), [url]: color })); } catch { /* sin storage */ }
        resolve(color);
      } catch {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = `${url}${url.includes('?') ? '&' : '?'}medir`;
  });

  promesas.set(url, promesa);
  return promesa;
}
